import { render } from "./Profile.vue?vue&type=template&id=903efed6&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=903efed6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-903efed6"

export default script